/** Full page navigation — server routes such as /api/*.pdf are not SPA routes. */
export function assignLocation(url: string): void {
  window.location.assign(url);
}
